import {
  SET_LAST_INSIGHT_PAGE,
  SET_LAST_AUDIENCE_BUILDER_PAGE,
  SET_LAST_CAMPAIGN_SUMMARY_PAGE
} from '../constants';

const initialState = {
  lastInsightPage: null,
  lastAudienceBuilderPage: null,
  lastCampaignSummaryPage: null,
};


const route = (state = initialState, action) => {
  switch (action.type) {
    case SET_LAST_INSIGHT_PAGE:
      return {
        ...state,
        lastInsightPage: action.data
      };
    case SET_LAST_AUDIENCE_BUILDER_PAGE:
        return {
          ...state,
          lastAudienceBuilderPage: action.data
        };
    case SET_LAST_CAMPAIGN_SUMMARY_PAGE:
      return{
        ...state,
        lastCampaignSummaryPage: action.data
      }

    default:
      return state;
  }
};

export default route;
